import cn from 'classnames';
import React, {CSSProperties, ReactElement, FC} from 'react';

import './ais-dashboard-card.less';

interface IAisDashboardCardProps {
    children: any;
    title: string;
    style?: CSSProperties;
    className?: cn.Argument;
    bodyClassName?: cn.Argument;
    footer?: ReactElement;
}

export const AisDashboardCard: FC<IAisDashboardCardProps> = (
    {
        title, children, style, bodyClassName, className, footer,
    }: IAisDashboardCardProps,
) => (
    <div
        className={cn('ais-dashboard-card', className)}
        style={style}
    >
        <div className={cn('ais-dashboard-card__title')}>{title}</div>
        <div className={cn('ais-dashboard-card__body', bodyClassName)}>{children}</div>
        {footer && <div className={cn('ais-dashboard-card__footer')}>{footer}</div>}
    </div>
);
